import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class JsonDataService {
  constructor(private readonly http: HttpClient) {}

  // Function to fetch the JSON file with headers
  getJsonData(): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    // Assuming you're fetching from 'assets/data.json'
    return this.http.get('assets/json/apple-app-site-association.json', { headers });

  }
}
